import { ZERO_BIG_NUMBER } from '@ui/lib/bignumber';
import { PossibleBigNumber } from '@ui/types/utility';

export const getBalanceAfterGas = ({
  balance,
  gasFee,
  isNative,
}: {
  balance: PossibleBigNumber;
  gasFee: PossibleBigNumber;
  isNative: boolean | undefined;
}) => {
  const balanceAfterGasFee = gasFee ? balance?.minus(gasFee) : balance;

  return isNative
    ? balanceAfterGasFee?.gt(0)
      ? balanceAfterGasFee
      : ZERO_BIG_NUMBER
    : balance;
};
